import { TranslateLanguage } from './KeywordTranslator';

const SOURCE_CONFIG = {
  CGNTV: {
    playlistId: 'UUqUnxXxHSFb6At-njlSX9AQ',
    sourceURL: 'https://www.youtube.com/@CGNChinese_%E6%B4%BB%E6%BD%91%E7%9A%84%E7%94%9F%E5%91%BD',
  },
  CAI: {
    playlistId: 'UUfEbx5pXwoQuj-Y2M6zsDfw',
    sourceURL: 'https://www.youtube.com/user/lalapraise',
  },
  GCH: {
    playlistId: 'PLD0gACwZoIrs2s9GeX1Skk5B7L7MHkn3a',
    sourceURL: 'https://www.youtube.com/playlist?list=PLD0gACwZoIrs2s9GeX1Skk5B7L7MHkn3a',
    weekdaysOnly: true,
  },
};

const toLocalDateKey = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const parseQTVideoDate = (title = '') => {
  const match = String(title).match(/(20\d{2})\s*(?:[.\-/年]\s*)?(\d{1,2})\s*(?:[.\-/月]\s*)?(\d{1,2})(?:\s*日)?/);
  if (!match) return '';

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(year, month - 1, day);

  if (
    parsed.getFullYear() !== year
    || parsed.getMonth() !== month - 1
    || parsed.getDate() !== day
  ) {
    return '';
  }

  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

const buildSourceMessage = (config, message) => (
  `<p>${message}</p><p><a target="_blank" rel="noreferrer" href="${config.sourceURL}">`
  + `${TranslateLanguage(localStorage.userLanguage, '前往原始來源')}</a></p>`
);

export const loadQTArchiveWithOption = async (qtOption, YTKey) => {
  const config = SOURCE_CONFIG[qtOption];
  if (!config) return { items: [], message: '', sourceURL: '' };

  const requestURL = 'https://www.googleapis.com/youtube/v3/playlistItems'
    + `?part=snippet&maxResults=50&playlistId=${config.playlistId}&key=${YTKey}`;
  const response = await fetch(requestURL);
  if (!response.ok) {
    throw new Error(`YouTube request failed with status ${response.status}`);
  }

  const data = await response.json();
  const videosByDate = new Map();

  for (const item of data?.items ?? []) {
    const snippet = item?.snippet;
    const title = snippet?.title || '';
    const videoId = snippet?.resourceId?.videoId;
    if (!videoId || !title.includes('活潑的生命')) continue;

    const date = parseQTVideoDate(title);
    if (!date || videosByDate.has(date)) continue;

    videosByDate.set(date, {
      date,
      text: title,
      videoId,
      url: `https://www.youtube.com/watch?v=${videoId}`,
      publishedAt: snippet.publishedAt || '',
      thumbnail: snippet.thumbnails?.medium?.url || snippet.thumbnails?.default?.url || '',
    });
  }

  const items = Array.from(videosByDate.values())
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 20);
  const now = new Date();
  const isWeekend = now.getDay() === 0 || now.getDay() === 6;
  let message = TranslateLanguage(
    localStorage.userLanguage,
    '抱歉，沒有找到可播放的內容，請稍後再試。'
  );

  if (config.weekdaysOnly && isWeekend) {
    message = TranslateLanguage(
      localStorage.userLanguage,
      '該頻道只有週一至週五有內容，您仍可選擇之前的日期。'
    );
  }

  return {
    items,
    sourceURL: config.sourceURL,
    message: buildSourceMessage(config, message),
  };
};

export const loadQTWithOption = async (qtOption, YTKey) => {
  const archive = await loadQTArchiveWithOption(qtOption, YTKey);
  const todayVideo = archive.items.find(item => item.date === toLocalDateKey());

  if (todayVideo) {
    return { url: todayVideo.url, text: todayVideo.text };
  }

  return { url: '', text: archive.message };
};
